module.exports = __webpack_public_path__ + "static/media/avatar.8686f624.svg";